import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcReview(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 7.334a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 .75-.75M12.25 13.084a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5zM17 10.834a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 .75-.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.472 17.63-3.734 3.578a.75.75 0 0 1-1.27-.542v-2.139c-3.925-.473-6.968-3.85-6.968-7.901 0-4.418 3.582-8.042 8-8.042h3a8 8 0 1 1 0 16h-.024zM10.5 4.084h3a6.5 6.5 0 0 1 .435 12.986l.374.39-.376-.392-.511.02h-.58l-1.873 1.821v-1.82l-1.5-.08v.004C6.382 16.55 4 13.856 4 10.626c0-3.6 2.92-6.542 6.5-6.542",
    clipRule: "evenodd"
  }));
}
var IcReview = createNolIcon(/*#__PURE__*/forwardRef(SvgIcReview));

export { IcReview as I };
